import { useCallback } from 'react';
import { ApolloQueryResult, useApolloClient } from '@apollo/client';

import { Timetable, TimetableInput } from '@typings/api';

import { TIME_TABLE } from '../../queries';

interface Options {
  onError?: (error: any) => void;
}

export function useTimeTableQuery(options?: Options) {
  const client = useApolloClient();

  const getTimetable = useCallback(
    async (
      timetableInput: TimetableInput,
    ): Promise<ApolloQueryResult<Timetable> | undefined> => {
      return await client
        .query({
          query: TIME_TABLE,
          variables: {
            timetableInput,
          },
          fetchPolicy: 'no-cache',
        })
        .catch((error) => {
          if (options?.onError !== undefined) {
            options.onError(error);
          }

          return undefined;
        });
    },
    [client, options],
  );

  return [getTimetable];
}
